import { createSlice } from '@reduxjs/toolkit';
import { WebStorageClient } from "../clients/webStorage.client";
import { WEB_STORAGE_KEYS } from "../clients/clients.constants";

const initialOptions = {
  brand: {
    options: [],
    selected: [],
    searchQuery: "",
  },
  siteType: {
    options: [],
    selected: [],
    searchQuery: ""
  },
  region: {
    options: [],
    selected: [],
    searchQuery: "",
  },
  countryState: {
    options: [],
    selected: [],
    searchQuery: "",
  }
};

const initialState = WebStorageClient.getByKey(WEB_STORAGE_KEYS.ALERTS_FILTERS) || initialOptions;

const alertsFiltersOptionsSlice = createSlice({
  name: 'alertsFiltersOptions',
  initialState,
  reducers: {
    setFilterOptions(state, action) {
      state[action.payload.filterName] = action.payload.options;
    },
    setSearchQuery(state, action) {
      state[action.payload.filterName].searchQuery = action.payload.query;
    },
    setSelectedOptions(state, action) {
      state[action.payload.filterName].selected = action.payload.selectedOptions;
    },
  },
});

export const { setFilterOptions, setSearchQuery, setSelectedOptions } = alertsFiltersOptionsSlice.actions;

export default alertsFiltersOptionsSlice.reducer;
